import './Wizard.scss'
import { MdOutlineCheck } from 'react-icons/md'
import { clx } from '../clx'
import { VisuallyHidden } from '../VisuallyHidden'

export interface WizardStep {
  id: string
  title: string
}

export interface StepperProps {
  steps: readonly WizardStep[]
  /** Zero-based index of the current step. */
  current: number
  /** Accessible name of the list. */
  label?: string
  className?: string
}

/**
 * Progress through a wizard: an ordered list with the current step marked
 * `aria-current="step"`. Below tablet it collapses to "Step 2 of 3 — Title";
 * only one of the two is displayed (and so exposed) at a time.
 */
export function Stepper({ steps, current, label = 'Progress', className }: StepperProps) {
  const step = steps[current]
  return (
    <div className={clx('stepper', className)}>
      <p className="stepper__compact">
        Step {current + 1} of {steps.length}
        {step && ` — ${step.title}`}
      </p>
      <ol className="stepper__list" aria-label={label}>
        {steps.map((s, i) => {
          const state = i < current ? 'complete' : i === current ? 'current' : 'upcoming'
          return (
            <li
              key={s.id}
              className="stepper__step"
              data-state={state}
              aria-current={i === current ? 'step' : undefined}
            >
              <span className="stepper__marker" aria-hidden="true">
                {state === 'complete' ? <MdOutlineCheck /> : i + 1}
              </span>
              <span className="stepper__title">
                {s.title}
                {state === 'complete' && <VisuallyHidden> (completed)</VisuallyHidden>}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
